import React, { useState } from 'react';
import { CARD_VIEW_V2_WIDTH_BY_LAYOUT_SIZE } from '@/utils/card-view-v2-layout';
import { FlatList, StyleSheet } from 'react-native';
import { HorizontalListArrows } from '@/components/horizontal-list-arrows';
import { ItemListOption } from '@/contexts/item-context-types';
import { MinimalOrderableItemListItem } from '@/components/minimal-orderable-item-list-item';
import { MinimalOrderableItemListItemV2 } from '@/components/minimal-orderable-item-list-item-v2';
import { RenderActionsFn } from './item-detail-actions';
import { UpdateQuantityFn } from '@/contexts/new-order-actions-context-types';
import {
  useLayoutContext,
  useLayoutSizeValue,
} from '@/contexts/layout-context';
import { useSupplierDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

interface Props {
  items: ItemListOption[];
  onSelect: (item: ItemListOption) => void;
  renderActions?: RenderActionsFn;
  updateQuantity: UpdateQuantityFn;
}

const LARGE_SCREEN_VISIBLE_ITEMS = 4;

export const ItemDetailsRecommendedItemList: React.FC<Props> = ({
  items,
  onSelect,
  updateQuantity,
  renderActions,
}) => {
  const { isLargeLayout } = useLayoutContext();
  const newItemCardEnabled = useSupplierDynamicConfigValue(
    'card_view_v2_enabled',
    false,
  );
  const cardV2Width = useLayoutSizeValue(CARD_VIEW_V2_WIDTH_BY_LAYOUT_SIZE);
  const [layoutWidth, setLayoutWidth] = useState(0);

  return (
    <HorizontalListArrows<ItemListOption>
      arrowShape="round"
      trackingKey="item-detail-recs"
    >
      {(listProps) => (
        <FlatList<ItemListOption>
          {...listProps}
          data={items}
          decelerationRate="fast"
          horizontal
          onLayout={(e) => {
            // must call the prop passed from the arrow component to calculate
            // where arrows should render
            listProps.onLayout?.(e);
            setLayoutWidth(e.nativeEvent.layout.width);
          }}
          renderItem={({ item }) => {
            if (newItemCardEnabled) {
              return (
                <MinimalOrderableItemListItemV2
                  item={item}
                  onSelect={() => onSelect(item)}
                  size="large"
                  updateQuantity={updateQuantity}
                  width={cardV2Width}
                />
              );
            }

            return (
              <MinimalOrderableItemListItem
                item={item}
                onSelect={() => onSelect(item)}
                renderActions={renderActions}
                size={isLargeLayout ? 'large' : 'small'}
                source="item_details_recommendations"
                updateQuantity={updateQuantity}
                width={
                  isLargeLayout
                    ? Math.floor(layoutWidth / LARGE_SCREEN_VISIBLE_ITEMS)
                    : undefined
                }
              />
            );
          }}
          showsHorizontalScrollIndicator={false}
          style={styles.list}
        />
      )}
    </HorizontalListArrows>
  );
};

const styles = StyleSheet.create({
  list: {
    overflow: 'visible',
  },
});
